const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/modal/notice_button.jsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Badge } from "primereact/badge";
import { Divider } from "primereact/divider";
import { Image } from "primereact/image";
import { Menu } from "primereact/menu";
import { OverlayPanel } from "primereact/overlaypanel";
import { ScrollPanel } from "primereact/scrollpanel";
import { useTranslation } from "react-i18next";
import "./modal.css";
import noticeIcon from "../../../assets/images/notificationicon.png";
import { apiPatchReadNotification } from "../../../services/api/notification";
import createRoleAccess, { getRoleFromSocial } from "../../utils/role_access";
import { normalizeLanguage } from "../../../i18n/language";

const GROUP_NOTIFICATION_TYPES = [
    "GROUP_MEMBER_REQUEST",
    "ACCEPTED_GROUP_MEMBER_REQUEST",
    "REJECTED_GROUP_MEMBER_REQUEST",
    "GROUP_MEMBER_POSTED",
];

const FEED_NOTIFICATION_TYPES = [
    "COMMENT_ON_POST",
    "LIKE_ON_POST",
    "REPLY_ON_COMMENT",
];

const FRIEND_NOTIFICATION_TYPES = [
    "FRIEND_REQUEST",
    "ACCEPTED_FRIEND_REQUEST",
];

const EDUCATIONAL_MEDIA_NOTIFICATION_TYPES = ["NEW_EDUCATIONAL_MEDIA"];

const NOTIFICATION_MESSAGE_KEYS = {
    COMMENT_ON_POST: "notification.messages.commentOnPost",
    LIKE_ON_POST: "notification.messages.likeOnPost",
    REPLY_ON_COMMENT: "notification.messages.replyOnComment",
    FRIEND_REQUEST: "notification.messages.friendRequest",
    ACCEPTED_FRIEND_REQUEST: "notification.messages.acceptedFriendRequest",
    GROUP_MEMBER_POSTED: "notification.messages.groupMemberPosted",
    GROUP_MEMBER_REQUEST: "notification.messages.groupMemberRequest",
    ACCEPTED_GROUP_MEMBER_REQUEST:
        "notification.messages.acceptedGroupMemberRequest",
    REJECTED_GROUP_MEMBER_REQUEST:
        "notification.messages.rejectedGroupMemberRequest",
    NEW_EDUCATIONAL_MEDIA: "notification.messages.newEducationalMedia",
};

const DATE_LOCALE_MAP = {
    th: "th-TH",
    en: "en-US",
    id: "id-ID",
    ms: "ms-MY",
    my: "my-MM",
    lo: "lo-LA",
};

const NoticeButton = ({ notifications, count, loadNotice }) => {
    const { t, i18n } = useTranslation();
    const op = useRef(null);
    const [isPanelVisible, setIsPanelVisible] = useState(false);
    const menuRef = useRef(null);

    const userinfo = JSON.parse(localStorage.getItem("social_user_info"));
    const rolePermission = getRoleFromSocial(_optionalChain([userinfo, 'optionalAccess', _ => _.role_id]));
    const role = createRoleAccess(rolePermission);
    const parsedNotificationCount = Number(_optionalChain([count, 'optionalAccess', _2 => _2.count]));
    const notificationCount = Number.isFinite(parsedNotificationCount)
        ? Math.max(0, Math.trunc(parsedNotificationCount))
        : 0;
    const notificationCountLabel =
        notificationCount > 99 ? "99+" : notificationCount;

    const newNotifications = _optionalChain([notifications, 'optionalAccess', _3 => _3.notifications, 'optionalAccess', _4 => _4.filter, 'call', _5 => _5((noti) =>
        FEED_NOTIFICATION_TYPES.includes(noti.noti_type)
    )]);
    const friendRequests = _optionalChain([notifications, 'optionalAccess', _6 => _6.notifications, 'optionalAccess', _7 => _7.filter, 'call', _8 => _8((noti) =>
        FRIEND_NOTIFICATION_TYPES.includes(noti.noti_type)
    )]);
    const groupRequests = _optionalChain([notifications, 'optionalAccess', _9 => _9.notifications, 'optionalAccess', _10 => _10.filter, 'call', _11 => _11((noti) =>
        GROUP_NOTIFICATION_TYPES.includes(noti.noti_type)
    )]);
    const educationalMedia = _optionalChain([notifications, 'optionalAccess', _12 => _12.notifications, 'optionalAccess', _13 => _13.filter, 'call', _14 => _14((noti) =>
        EDUCATIONAL_MEDIA_NOTIFICATION_TYPES.includes(noti.noti_type)
    )]);

    const redirectProfile = (item) => {
        const socialBase = process.env.REACT_APP_SOCIAL_URL;

        if (GROUP_NOTIFICATION_TYPES.includes(item.noti_type)) {
            if (!item.group_id) return;
            window.location.assign(`${socialBase}/app/groups/${item.group_id}`);
        } else if (FRIEND_NOTIFICATION_TYPES.includes(item.noti_type)) {
            if (item.user_id === userinfo.id) {
                window.location.assign(`${socialBase}/app/profile`);
            } else {
                window.location.assign(`${socialBase}/app/profile/${item.user_id}`);
            }
        } else if (FEED_NOTIFICATION_TYPES.includes(item.noti_type)) {
            window.location.assign(`${socialBase}/app/feed/${item.post_id}`);
        } else if (
            EDUCATIONAL_MEDIA_NOTIFICATION_TYPES.includes(item.noti_type)
        ) {
            window.location.assign(`${socialBase}/app/teaching_hub`);
        }
    };

    const generateMessage = (noti) =>
        t(NOTIFICATION_MESSAGE_KEYS[noti.noti_type] || "notification.messages.default");

    const formatTime = (datetime) => {
        const date = new Date(datetime);
        const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

        return date.toLocaleString(DATE_LOCALE_MAP[language] || "th-TH", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const renderNotiRow = (noti) => {
        const sender =
            _optionalChain([notifications, 'optionalAccess', _15 => _15.users, 'access', _16 => _16[noti.user_id]]) ||
            _optionalChain([notifications, 'optionalAccess', _17 => _17.users, 'access', _18 => _18[noti.user_relation_id]]) ||
            {};
        const group = _optionalChain([notifications, 'optionalAccess', _19 => _19.groups, 'optionalAccess', _20 => _20[noti.group_id]]) || {};
        const isFriendAcceptedNoti = ["ACCEPTED_FRIEND_REQUEST"].includes(
            noti.noti_type
        );
        const isGroupNoti = GROUP_NOTIFICATION_TYPES.includes(noti.noti_type);

        const avatarSrc = isGroupNoti
            ? group.avatar_photo
                ? `data:image/jpeg;base64,${group.avatar_photo}`
                : "/default_user.png"
            : sender.pic_profile
            ? `data:image/jpeg;base64,${sender.pic_profile}`
            : "/default_user.png";

        let senderName = "";

        if (!isFriendAcceptedNoti) {
            if (isGroupNoti) {
                senderName = _optionalChain([group, 'optionalAccess', _21 => _21.name])
                    ? `${group.name}: `
                    : `${t("notification.unknownGroup")}: `;
            } else if (_optionalChain([sender, 'optionalAccess', _22 => _22.first_name])) {
                senderName = `${sender.first_name} ${sender.last_name}: `;
            } else {
                senderName = `${t("notification.unknownUser")}: `;
            }
        }

        const handleClick = async () => {
            try {
                await apiPatchReadNotification([noti.id]);
                redirectProfile(noti);
                loadNotice();
            } catch (error) {
                console.error("Failed to mark as read:", error);
            }
        };

        const avatarClass = _optionalChain([group, 'optionalAccess', _23 => _23.id]) ? "noti-group-avatar" : "noti-avatar";

        return (
            React.createElement(Row, {
                key: noti.id,
                className: "notification-row mb-2" ,
                onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}

                , React.createElement(Col, { xs: 3, className: "ml-2 pr-0 text-center"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
                    , React.createElement('img', { src: avatarSrc, alt: "avatar", className: avatarClass, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
                )
                , React.createElement(Col, { xs: 7, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
                    , React.createElement('div', { className: "noti-message pl-0" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
                        , senderName && React.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}, senderName)
                        , generateMessage(noti)
                    )
                    , React.createElement('div', { className: "noti-time text-muted" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
                        , formatTime(noti.created_at)
                    )
                )
                , React.createElement(Col, { xs: 1, className: "pt-2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
                    , !noti.read_at && React.createElement('span', { className: "unread-dot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}} )
                )
            )
        );
    };

    const handleClick = (e) => {
        op.current.toggle(e);
        setIsPanelVisible((prev) => !prev);
    };

    const markAllAsRead = async () => {
        const ids = _optionalChain([notifications, 'optionalAccess', _24 => _24.notifications, 'optionalAccess', _25 => _25.map, 'call', _26 => _26((noti) => noti.id)]) || [];
        if (ids.length === 0) return;

        try {
            await apiPatchReadNotification([ids]);
            loadNotice();
        } catch (error) {
            console.error("Mark all as read failed", error);
        }
    };

    const menuItems = [
        {
            label: t("notification.markAllRead"),
            icon: "pi pi-check",
            command: () => markAllAsRead(),
        },
    ];

    return (
        React.createElement('div', { className: "menu-group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}}
            , React.createElement(Image, {
                className: `${
                    isPanelVisible ? "menu-icon-selected" : "menu-icon"
                }`,
                onClick: handleClick,
                src: noticeIcon,
                alt: t("notification.title", {
                    count: notificationCountLabel,
                }),
                width: "55px",
                height: "45px", __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}}
            )

            , notificationCount > 0 && (
                React.createElement(Badge, {
                    className: "noti-badge",
                    value: notificationCountLabel,
                    onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
                )
            )

            , React.createElement(OverlayPanel, {
                ref: op,
                className: "overlay-panel",
                onHide: () => setIsPanelVisible(false),
                dismissable: true,
                style: { width: "350px", height: "450px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}

                , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
                    , React.createElement('div', { className: "overlay-title p-2 d-flex"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}
                        , t("notification.title", {
                            count: notificationCountLabel,
                        })
                        , React.createElement('div', { className: "align-self-baseline ms-auto" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
                            , React.createElement('i', {
                                className: "pi pi-ellipsis-h cursor-pointer text-color-ms"   ,
                                style: { fontSize: "1rem" },
                                onClick: (e) => menuRef.current.toggle(e), __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
                            )
                            , React.createElement(Menu, {
                                model: menuItems,
                                popup: true,
                                ref: menuRef,
                                className: "custom-notify-menu",
                                baseZIndex: 10002, __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}
                            )
                        )
                    )
                )

                , React.createElement(ScrollPanel, { className: "notification-scroll-panel", __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}
                    , _optionalChain([newNotifications, 'optionalAccess', _27 => _27.length]) > 0 && (
                        React.createElement(React.Fragment, null
                            , React.createElement('div', { className: "section-header d-flex justify-content-between align-items-center mb-2 mx-3"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
                                , React.createElement('span', { className: "section-title text-color-ms" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
                                    , t("notification.sections.new")
                                )
                                , React.createElement('span', { className: "section-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}
                                    , t("common.actions.viewAll")
                                )
                            )
                            , _optionalChain([newNotifications, 'optionalAccess', _28 => _28.map, 'call', _29 => _29(renderNotiRow)])
                            , React.createElement(Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 285}} )
                        )
                    )
                    , _optionalChain([friendRequests, 'optionalAccess', _30 => _30.length]) > 0 && (
                        React.createElement(React.Fragment, null
                            , React.createElement('div', { className: "section-header d-flex justify-content-between align-items-center mt-3 mb-2 mx-3"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
                                , React.createElement('span', { className: "section-title text-color-ms" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}}
                                    , t("notification.sections.friendRequests")
                                )
                                , React.createElement('span', { className: "section-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}}
                                    , t("common.actions.viewAll")
                                )
                            )
                            , _optionalChain([friendRequests, 'optionalAccess', _31 => _31.map, 'call', _32 => _32(renderNotiRow)])
                            , React.createElement(Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 299}} )
                        )
                    )
                    , _optionalChain([groupRequests, 'optionalAccess', _33 => _33.length]) > 0 && (
                        React.createElement(React.Fragment, null
                            , React.createElement('div', { className: "section-header d-flex justify-content-between align-items-center mt-3 mb-2 mx-3"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}
                                , React.createElement('span', { className: "section-title text-color-ms" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}}
                                    , t("notification.sections.groupRequests")
                                )
                                , React.createElement('span', { className: "section-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}}
                                    , t("common.actions.viewAll")
                                )
                            )
                            , _optionalChain([groupRequests, 'optionalAccess', _34 => _34.map, 'call', _35 => _35(renderNotiRow)])
                        )
                    )
                    , role.canViewTeachingHubFeed &&
                        _optionalChain([educationalMedia, 'optionalAccess', _36 => _36.length]) > 0 && (
                            React.createElement(React.Fragment, null
                                , React.createElement('div', { className: "section-header d-flex justify-content-between align-items-center mt-3 mb-2 mx-3"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 318}}
                                    , React.createElement('span', { className: "section-title text-color-ms" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 319}}
                                        , t(
                                            "notification.sections.educationalMedia"
                                        )
                                    )
                                    , React.createElement('span', { className: "section-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 324}}
                                        , t("common.actions.viewAll")
                                    )
                                )
                                , _optionalChain([educationalMedia, 'optionalAccess', _37 => _37.map, 'call', _38 => _38(renderNotiRow)])
                            )
                        )
                )
            )
        )
    );
};

export default NoticeButton;
